<app-document-table
  [subtitle]="rootFolderName() ? 'Indice: ' + rootFolderName() : 'Gestione documenti in errore'"
  [basePath]="targetIndex() ? 'error/' + targetIndex() + '/' : 'error/'" 
  [documents]="documents()"
  [isLoading]="isLoading()"
  [loadingMessage]="loadingMessage()"
  [hasError]="hasError()"
  
  [showInfoAction]="true"
  (infoActionClicked)="openErrorDetail($event)"
  
  [showSelection]="true" 
  (selectionChanged)="onSelectionChanged($event)"
  (pathChanged)="currentPath.set($event)"
  
  [showIngestButton]="true"
  [ingestEnabled]="canRunIngestion()"
  [isProcessing]="isProcessing()" 
  (ingestClicked)="openIngestionModal()"> 

  <div table-actions class="table-actions-wrapper">
    
    @if (selectedItems().length > 0) {
      <div class="selection-counter">
        <span class="text-muted fw-bold counter-text">
          {{ selectedItems().length }} selezionati
        </span>
      </div>
    }
    
  </div>

</app-document-table> 

@if (isModalOpen()) {
  <div class="modal-backdrop" tabindex="-1" aria-hidden="true" (click)="closeModal()" (keydown.enter)="closeModal()">
    <div class="modal-dialog" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
      
      <div class="modal-header">
        <div class="modal-title">
          <span class="material-symbols-outlined text-red">error</span>
          <h3>Dettaglio Errore</h3>
        </div>
        <button class="close-btn" (click)="closeModal()">
          <span class="material-symbols-outlined">close</span>
        </button>
      </div>

      <div class="modal-body">
        @if (isFetchingError()) {
          <div class="loading-state">
            <span class="material-symbols-outlined rotating">progress_activity</span>
            <p>Recupero dettagli in corso...</p>
          </div>
        } @else {
          <div class="error-box">
            <p>{{ errorDetailMessage() }}</p>
          </div>
        }
      </div>

    </div>
  </div>
}